/* import __COLOCATED_TEMPLATE__ from './toast.hbs'; */
var _dec, _dec2, _dec3, _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@ember/component';
import { FLASH_TYPES } from '@square/glass-ui/utils/flash-types';
import { computed } from '@ember/object';
import infoCircleIconComponent from '@square/glass-ui/components/svg/icon-info-circle';
import checkmarkCircleIconComponent from '@square/glass-ui/components/svg/icon-checkmark-circle';
import alertTriangleIconComponent from '@square/glass-ui/components/svg/icon-alert-triangle';
let Toast = (_dec = computed('type'), _dec2 = computed('type'), _dec3 = computed('type'), (_class = class Toast extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "isActive", null);
    _defineProperty(this, "message", null);
    _defineProperty(this, "type", '');
  }
  get typeClass() {
    switch (this.type) {
      case FLASH_TYPES.ERROR:
        return 'toast-flash--is-error';
      default:
        return '';
    }
  }
  get iconComponentName() {
    switch (this.type) {
      case FLASH_TYPES.ERROR:
        return infoCircleIconComponent;
      case FLASH_TYPES.SUCCESS:
        return checkmarkCircleIconComponent;
      case FLASH_TYPES.WARNING:
        return alertTriangleIconComponent;
      default:
        return infoCircleIconComponent;
    }
  }
  get iconColor() {
    switch (this.type) {
      case FLASH_TYPES.ERROR:
        return 'white';
      case FLASH_TYPES.SUCCESS:
        return 'green';
      case FLASH_TYPES.WARNING:
        return 'gold';
      default:
        return 'blue-medium';
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "typeClass", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "typeClass"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "iconComponentName", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "iconComponentName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "iconColor", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "iconColor"), _class.prototype)), _class));
export { Toast as default };